import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/live/classify/new',
    owner: '/home',
    authority: 'liveClassifyItemAdd',
    component: Loadable({
      loader: () => import('./new'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/live/classify/:id/mod',
    owner: '/home',
    authority: 'liveClassifyItemMod',
    component: Loadable({
      loader: () => import('./mod'),
      loading: () => <RouteLoading />
    })
  },
];